export const downloadAndGenerateCsv = (
  csv: string,
  onSuccess?: (successUrl: string) => void,
  onError?: () => void
) => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

  const urlToView = URL.createObjectURL(blob);

  window.open(`${urlToView}`, "_blank")?.focus();

  if (!urlToView && onError) onError();

  if (onSuccess) onSuccess(urlToView);
};
